import {
  Alert,
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import FilterBar from "../Reusable/FilterBar";
import RefreshIcon from "@mui/icons-material/Refresh";
import useUniversitiesList from "../../hooks/useUniversitiesList";
import api from "../../axiosInstance";
import PurchasedUsers from "../Users/PurchasedUsers";
import { useFormik } from "formik";
import * as Yup from "yup";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import InventoryIcon from "@mui/icons-material/Inventory";
import ReplayIcon from "@mui/icons-material/Replay";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import BalanceIcon from "@mui/icons-material/Balance";
import DownloadIcon from "@mui/icons-material/Download";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
// Helper function to get date ranges
const getDateRange = (range) => {
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];

  switch (range) {
    case "today":
      return { startDate: todayStr, endDate: todayStr };
    case "yesterday":
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayStr = yesterday.toISOString().split("T")[0];
      return { startDate: yesterdayStr, endDate: yesterdayStr };
    case "last2days":
      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
      const twoDaysAgoStr = twoDaysAgo.toISOString().split("T")[0];
      return { startDate: twoDaysAgoStr, endDate: todayStr };
    case "last7days":
      const weekAgo = new Date(today);
      weekAgo.setDate(weekAgo.getDate() - 7);
      const weekAgoStr = weekAgo.toISOString().split("T")[0];
      return { startDate: weekAgoStr, endDate: todayStr };
    case "last30days":
      const monthAgo = new Date(today);
      monthAgo.setDate(monthAgo.getDate() - 30);
      const monthAgoStr = monthAgo.toISOString().split("T")[0];
      return { startDate: monthAgoStr, endDate: todayStr };
    case "last2months":
      const twoMonthsAgo = new Date(today);
      twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);
      const twoMonthsAgoStr = twoMonthsAgo.toISOString().split("T")[0];
      return { startDate: twoMonthsAgoStr, endDate: todayStr };
    case "last3months":
      const threeMonthsAgo = new Date(today);
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
      const threeMonthsAgoStr = threeMonthsAgo.toISOString().split("T")[0];
      return { startDate: threeMonthsAgoStr, endDate: todayStr };
    case "last6months":
      const sixMonthsAgo = new Date(today);
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
      const sixMonthsAgoStr = sixMonthsAgo.toISOString().split("T")[0];
      return { startDate: sixMonthsAgoStr, endDate: todayStr };
    case "lastyear":
      const yearAgo = new Date(today);
      yearAgo.setFullYear(yearAgo.getFullYear() - 1);
      const yearAgoStr = yearAgo.toISOString().split("T")[0];
      return { startDate: yearAgoStr, endDate: todayStr };
    default:
      return { startDate: "", endDate: "" };
  }
};
// Date Range Selector Component
const DateRangeSelector = ({ selectedRange, handleRangeSelect, formik }) => {
  const rangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last2days", label: "Last 2 Days" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "last2months", label: "Last 2 Months" },
    { value: "last3months", label: "Last 3 Months" },
    { value: "last6months", label: "Last 6 Months" },
    { value: "lastyear", label: "Last Year" },
    { value: "custom", label: "Custom Range" },
  ];

  return (
    <Box sx={{ textAlign: "left" }}>
      {/* <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        Quick Date Range
      </Typography> */}

      <FormControl fullWidth size="small">
        <InputLabel>Select Quick Date Range</InputLabel>
        <Select
          value={selectedRange}
          label="Select  Quick Date Range"
          onChange={(e) => handleRangeSelect(e.target.value)}
        >
          {rangeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

// Color for the target Text
const getStatusColor = (status) => {
  switch (status) {
    case "Below Target":
      return "red";
    case "Target":
      return "green";
    case "Near Target ":
      return "gray";
    default:
      return "text.secondary";
  }
};
function SalesReports() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openImage, setOpenImage] = useState(null);
  const [bannerEdit, setBannerEdit] = useState(null);
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("createdAt");
  const [order, setOrder] = useState("asc");
  const [value, setValue] = useState(0);
  const [states, setStates] = useState([]);
  const [selectedstates, setSelectedStates] = useState("1" || "");
  const [universityList, setUniversityList] = useState([]);
  const [collegeList, setCollegeList] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [collegeId, setCollegeId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [regulationId, setRegulationId] = useState("");
  const [isFiltersLoaded, setIsFiltersLoaded] = useState(false);
  const [selectedRange, setSelectedRange] = useState("today");
  const [coursesList, setCoursesList] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [summaryList, setSummaryList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [couponsData, setCouponsData] = useState([]);
  console.log(couponsData);

  // State values onchanges
  const handleChange = (event) => {
    setSelectedStates(event.target.value);
  };

  const formik = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
    },
    validationSchema: Yup.object({
      startDate: Yup.string().required(),
      endDate: Yup.string().required(),
    }),
  });

  // Handle select range
  const handleRangeSelect = (range) => {
    setSelectedRange(range);

    const { startDate, endDate } = getDateRange(range);
    // Update Formik values
    formik.setFieldValue("startDate", startDate);
    formik.setFieldValue("endDate", endDate);
  };
  // update startDate and endDate values
  useEffect(() => {
    if (!selectedRange) return;
    let range = getDateRange(selectedRange);
    setStartDate(range.startDate);
    setEndDate(range.endDate);
  }, [selectedRange]);

  useEffect(() => {
    handleRangeSelect("today");
  }, []);
  //Fetching the States get Data
  useEffect(() => {
    setIsLoading(true);
    api
      .get("/getAllStates")
      .then((res) => setStates(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching messages";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, []);
  //Fetching the Universities list get Data
  useEffect(() => {
    setIsLoading(true);
    api
      .get("/getAllUniversities")
      .then((res) => setUniversityList(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching messages";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, []);
  // Fetch the All college list with dependency of university id
  useEffect(() => {
    if (!universityId) {
      setCollegeList([]);
      return;
    }
    setIsLoading(true);
    api
      .get(`/getColleges/${universityId}`)
      .then((res) => setCollegeList(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching messages";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, [universityId]);
  // Fetch the All course list with dependency of university id and college id
  //   useEffect(() => {
  //     if (!universityId) return;
  //     if (!collegeId) return; // stop unwanted API calls

  //     getCourses(collegeId, universityId);
  //   }, [collegeId, universityId]);
  useEffect(() => {
    if (!isFiltersLoaded) return;
    setIsLoading(true);

    let params = {};

    if (collegeId && collegeId !== 0) {
      // Only collegeId when selected
      params.collegeId = collegeId;
    } else if (universityId && universityId !== 0) {
      // Only universityId if collegeId not selected
      params.universityId = universityId;
    }

    api
      .get(`/getCourses/collegeId/universityId`, { params })
      .then((res) => setCoursesList(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching courses";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, [universityId, collegeId, isFiltersLoaded]);

  useEffect(() => {
    if (!isFiltersLoaded) return;
    setIsLoading(true);
    // if (!universityId || !courseId || !collegeId) {
    //   setSummaryList([]);
    //   return;
    // }
    api
      .get(`/api/v1/sales-dashboard/summary`, {
        params: {
          stateId: selectedstates,
          universityId: universityId,
          collegeId: collegeId,
          courseId: courseId,
          startDate: startDate,
          endDate: endDate,
        },
      })
      .then((res) => {
        setSummaryList(res.data.data);
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching courses";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, [
    selectedstates,
    startDate,
    endDate,
    courseId,
    universityId,
    collegeId,
    isFiltersLoaded,
  ]);
  // Fetch the Coupons Dashboard Values
  useEffect(() => {
    setIsLoading(true);
    // if (!universityId || !courseId || !collegeId) {
    //   setSummaryList([]);
    //   return;
    // }
    api
      .get(`/api/v1/sales-dashboard/coupons`)
      .then((res) => {
        setCouponsData(res.data.data);
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching courses";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, []);
  //  Load saved filters AFTER lists are loaded
  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem("SalesDashBoards"));
    if (savedFilters) {
      setUniversityId(savedFilters.universityId || "");
      setCourseId(savedFilters.courseId || "");
      setCollegeId(savedFilters.collegeId || "");
      setRegulationId(savedFilters.regulationId || "");
      setSelectedRange(savedFilters.selectedRange || "today");
      setStartDate(savedFilters.startDate || null);
      setEndDate(savedFilters.endDate || null);
    }
    setIsFiltersLoaded(true);
  }, []);

  //  Save filters whenever any change happens
  useEffect(() => {
    if (!isFiltersLoaded) return;
    const filtersToSave = {
      universityId,
      courseId,
      collegeId,
      regulationId,
      selectedRange,
      startDate,
      endDate,
    };
    localStorage.setItem("SalesDashBoards", JSON.stringify(filtersToSave));
  }, [
    universityId,
    courseId,
    collegeId,
    selectedRange,
    regulationId,
    startDate,
    endDate,
    isFiltersLoaded,
  ]);
  // reset the Local saved filters
  const [rotating, setRotating] = useState(false);
  const handleResetFilters = () => {
    setUniversityId("");
    setCourseId("");
    setCollegeId("");
    setRegulationId("");
    setSelectedRange("today");
    const todayRange = getDateRange("today");
    setStartDate(todayRange.startDate);
    setEndDate(todayRange.endDate);

    localStorage.removeItem("SalesDashBoards");
  };
  const handleClick = () => {
    setRotating(true);
    handleResetFilters?.();

    // Stop rotation after animation completes
    setTimeout(() => setRotating(false), 600); // match animation duration
  };

  // Build card objects from the dummy data

  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "flex-start", md: "space-between" },
          alignItems: { xs: "stretch", md: "center" },
          gap: { xs: 1, md: 0 },
          mb: 2,
          marginLeft: "10px",
          marginTop: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/SalesDashboard">
            Sales Dashboard
          </Link>
          {/* <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
           Dashboard
          </Typography> */}
        </Breadcrumbs>
      </Box>
      <Card
        sx={{
          margin: { xs: "0 8px", md: "0 14px" },
          boxShadow: 1,
        }}
      >
        <CardContent
          sx={{ padding: "0px 10px", paddingBottom: "0px !important" }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              {/* === Left Filters Section === */}
              <Grid item xs={12} md={10}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    alignItems: "center",
                    margin: "0px",
                    padding: "20px 10px",
                  }}
                >
                  {/* Books */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    sx={{
                      paddingTop: { md: "0px !important", xs: "10px" },
                      paddingLeft: {
                        md: "16px !important",
                        xs: "0px !important",
                      },
                    }}
                  >
                    <FormControl
                      sx={{
                        width: { xs: "80%", sm: 250 },
                      }}
                      size="small"
                    >
                      <InputLabel id="select-state-label">
                        Select State
                      </InputLabel>
                      <Select
                        labelId="select-state-label"
                        id="select-state"
                        sx={{ textAlign: "left" }}
                        value={selectedstates}
                        onChange={handleChange}
                        label="Select State"
                      >
                        {states.map((state) => (
                          <MenuItem key={state.id} value={state.id}>
                            {state.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    sx={{
                      paddingTop: { md: "0px !important", xs: "10px" },
                      paddingLeft: {
                        md: "16px !important",
                        xs: "0px !important",
                      },
                    }}
                  >
                    <FormControl
                      sx={{
                        width: { xs: "80%", sm: 250 },
                      }}
                      size="small"
                    >
                      <InputLabel id="select-university-label">
                        Select University
                      </InputLabel>

                      <Select
                        labelId="select-university-label"
                        id="select-university"
                        sx={{ textAlign: "left" }}
                        value={universityId}
                        onChange={(e) => {
                          const selected = e.target.value;
                          setUniversityId(selected);
                          setCollegeId("");
                        }}
                        label=" Select University"
                      >
                        {universityList.map((university) => (
                          <MenuItem key={university.id} value={university.id}>
                            {university.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    sx={{
                      paddingTop: { md: "0px !important", xs: "10px" },
                      paddingLeft: {
                        md: "16px !important",
                        xs: "0px !important",
                      },
                    }}
                  >
                    <Autocomplete
                      sx={{ width: { xs: "80%", sm: 250 } }}
                      size="small"
                      options={collegeList}
                      getOptionLabel={(option) =>
                        `${option.id} - ${option.name}`
                      }
                      value={
                        collegeList.find((clg) => clg.id === collegeId) || null
                      }
                      onChange={(event, newValue) => {
                        setCollegeId(newValue ? newValue.id : null);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select College" />
                      )}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    sx={{
                      paddingTop: { md: "0px !important", xs: "10px" },
                      paddingLeft: {
                        md: "16px !important",
                        xs: "0px !important",
                      },
                    }}
                  >
                    {console.log(coursesList)}

                    <FormControl fullWidth size="small">
                      <Autocomplete
                        sx={{ width: { xs: "80%", sm: 250 } }}
                        size="small"
                        options={coursesList}
                        getOptionLabel={(option) =>
                          `${option.courseId} - ${option.courseName}`
                        }
                        value={
                          coursesList.find(
                            (cours) => cours.courseId === courseId
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setCourseId(newValue ? newValue.courseId : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Courses" />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    sx={{
                      paddingTop: { md: "0px !important", xs: "10px" },
                      paddingLeft: {
                        md: "16px !important",
                        xs: "0px !important",
                      },
                    }}
                  >
                    <DateRangeSelector
                      selectedRange={selectedRange}
                      handleRangeSelect={handleRangeSelect}
                      formik={formik}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* === Right Side Toggle === */}
              <Grid
                item
                xs={12}
                md={2}
                sx={{
                  display: { xs: "none", md: "flex" },
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Button
                    onClick={handleClick}
                    variant="outlined"
                    sx={{
                      minWidth: "20px",
                      padding: "4px 4px",
                      borderRadius: "10px",
                      fontWeight: 600,
                      textTransform: "none",
                      color: "#17479e",
                      borderColor: "#17479e",
                      backgroundColor: "#f8f9ff",
                      transition: "all 0.3s ease",
                      boxShadow: "0 0 0 rgba(0,0,0,0)",
                      "&:hover": {
                        backgroundColor: "#17479e",
                        color: "#fff",
                        borderColor: "#17479e",
                        transform: "scale(1.05)",
                        boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                      },
                      "&:active": {
                        transform: "scale(0.98)",
                      },
                    }}
                  >
                    <RefreshIcon
                      sx={{
                        animation: rotating ? "spin 0.6s linear" : "none",
                        "@keyframes spin": {
                          "0%": { transform: "rotate(0deg)" },
                          "100%": { transform: "rotate(360deg)" },
                        },
                      }}
                    />
                  </Button>
                </Box>
              </Grid>
              <Typography
                sx={{
                  display: { xs: "none", md: "block" },
                  marginLeft: "20px",
                }}
                variant="body2"
                color="text.secondary"
              >
                {/* {sortedData.length} of {totalElements} messages items */}
              </Typography>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Typography
              sx={{
                display: { xs: "block", md: "none" },
                textAlign: "left",
                alignContent: "center",
              }}
              variant="body2"
              color="text.secondary"
            >
              {/* {sortedData.length} of {totalElements} messages items */}
            </Typography>

            <Grid
              item
              xs={12}
              md={2}
              sx={{
                display: { xs: "flex", md: "none" },
                gap: 4,
              }}
            >
              <Box>
                <Button
                  onClick={handleClick}
                  variant="outlined"
                  sx={{
                    minWidth: "20px",
                    padding: "4px 4px",
                    borderRadius: "10px",
                    fontWeight: 600,
                    textTransform: "none",
                    color: "#17479e",
                    borderColor: "#17479e",
                    backgroundColor: "#f8f9ff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 0 0 rgba(0,0,0,0)",
                    "&:hover": {
                      backgroundColor: "#17479e",
                      color: "#fff",
                      borderColor: "#17479e",
                      transform: "scale(1.05)",
                      boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                    },
                    "&:active": {
                      transform: "scale(0.98)",
                    },
                  }}
                >
                  <RefreshIcon
                    sx={{
                      animation: rotating ? "spin 0.6s linear" : "none",
                      "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                      },
                    }}
                  />
                </Button>
              </Box>
            </Grid>
          </Box>
          {/* CUSTOM RANGE DATE PICKERS */}
          {selectedRange === "custom" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                gap: 2,
                mb: 2,
                ml: 3,
                maxWidth: 1000,
              }}
            >
              <TextField
                label="From Date"
                type="date"
                name="startDate"
                value={formik.values.startDate}
                onChange={(e) => {
                  formik.handleChange(e);
                  setStartDate(e.target.value);
                }}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
              />
              <TextField
                label="To Date"
                type="date"
                name="endDate"
                value={formik.values.endDate}
                onChange={(e) => {
                  formik.handleChange(e);
                  setEndDate(e.target.value);
                }}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
              />
            </Box>
          )}
        </CardContent>
      </Card>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          gap: 2,
          margin: "20px",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        {/* ---------------- App Downloads ---------------- */}
        <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#a9c7f7a0",
                  }}
                >
                  <DownloadIcon sx={{ fontSize: 28, color: "#3b82f6" }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "30px",
                    color: "text.secondary",
                  }}
                >
                  {summaryList?.totalDownloads} +
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="16px"
                  fontWeight="550"
                  color="text.secondary"
                >
                  App Downloads
                </Typography>
                <Box sx={{ position: "relative", width: 64, height: 64 }}>
                  <svg width={64} height={64} viewBox="0 0 64 64">
                    <circle
                      cx="32"
                      cy="32"
                      r="26"
                      stroke="rgba(0,0,0,0.08)"
                      strokeWidth="6"
                      fill="none"
                    />
                    <circle
                      cx="32"
                      cy="32"
                      r="26"
                      stroke="#3b82f6"
                      strokeWidth="6"
                      fill="none"
                      strokeDasharray={2 * Math.PI * 26}
                      strokeDashoffset={
                        2 *
                        Math.PI *
                        26 *
                        (1 - (summaryList?.totalDownloads || 0) / 100)
                      }
                      strokeLinecap="round"
                    />
                  </svg>
                  <Typography
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                    }}
                  >
                    %
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* ---------------- Purchases ---------------- */}
        <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fcd5b4a0",
                  }}
                >
                  <MonetizationOnIcon sx={{ fontSize: 28, color: "#f97316" }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "30px",
                    color: "text.secondary",
                  }}
                >
                  {summaryList?.totalPurchasedUsers} +
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="16px"
                  fontWeight="550"
                  color="text.secondary"
                >
                  Total Puchases
                </Typography>
                <Box sx={{ position: "relative", width: 64, height: 64 }}>
                  <svg width={64} height={64} viewBox="0 0 64 64">
                    <circle
                      cx="32"
                      cy="32"
                      r="26"
                      stroke="rgba(0,0,0,0.08)"
                      strokeWidth="6"
                      fill="none"
                    />
                    <circle
                      cx="32"
                      cy="32"
                      r="26"
                      stroke="#f97316"
                      strokeWidth="6"
                      fill="none"
                      strokeDasharray={2 * Math.PI * 26}
                      strokeDashoffset={
                        2 *
                        Math.PI *
                        26 *
                        (1 -
                          Math.min(summaryList?.percentPurchased || 0, 100) /
                            100)
                      }
                      strokeLinecap="round"
                    />
                  </svg>
                  <Typography
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                    }}
                  >
                    {Math.round(summaryList?.percentPurchased || 0)}%
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* ---------------- Target ---------------- */}
        <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#b4f7d3a0",
                  }}
                >
                  <CrisisAlertIcon sx={{ fontSize: 28, color: "#10b981" }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "30px",
                    color: "text.secondary",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {summaryList?.courseTargetStatus === "Below Target" && (
                      <ArrowCircleDownIcon
                        sx={{ color: "red", fontSize: 40 }}
                      />
                    )}
                    {summaryList?.courseTargetStatus === "Target" && (
                      <ArrowCircleUpIcon
                        sx={{ color: "green", fontSize: 40 }}
                      />
                    )}
                    {summaryList?.courseTargetStatus === "Near Target" && (
                      <BalanceIcon sx={{ color: "gray", fontSize: 40 }} />
                    )}
                  </Box>
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="20px"
                  fontWeight="550"
                  sx={{
                    color: getStatusColor(summaryList?.courseTargetStatus),
                  }}
                >
                  {summaryList?.courseTargetStatus}
                  {summaryList?.courseTargetStatus === "above" &&
                    "Above Target"}
                  {summaryList?.courseTargetStatus === "onTarget" &&
                    "On Target"}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        {/* <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fcd5b4a0",
                  }}
                >
                  <ShoppingBagIcon sx={{ fontSize: 28, color: "#f97316" }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "30px",
                    color: "text.secondary",
                  }}
                >
                  {summaryList?.activeUsers} +
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="16px"
                  fontWeight="550"
                  color="text.secondary"
                >
                  Active Users
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid> */}
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          margin: "20px",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        {/* ---------------- Coupons Downloads ---------------- */}
        <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#a9c7f7a0",
                  }}
                >
                  <BookmarkIcon sx={{ fontSize: 28, color: "#3b82f6" }} />
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="16px"
                  fontWeight="550"
                  color="text.secondary"
                >
                  Total Coupons
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "30px",
                    color: "text.secondary",
                  }}
                >
                  {couponsData?.totalCoupons}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* ---------------- used Coupons ---------------- */}
        <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fcd5b4a0",
                  }}
                >
                  <BookmarkRemoveIcon sx={{ fontSize: 28, color: "#f97316" }} />
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="16px"
                  fontWeight="550"
                  color="text.secondary"
                >
                  Used Coupons
                </Typography>
                <Box sx={{ position: "relative", width: 64, height: 64 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: "30px",
                      color: "text.secondary",
                    }}
                  >
                    {couponsData?.usedCoupons}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid style={{ flex: "1 1 300px", maxWidth: 320 }}>
          <Card
            sx={{
              borderRadius: 2,
              height: 140,
              background: "rgba(255,255,255,0.7)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
              backdropFilter: "blur(10px)",
            }}
          >
            <CardContent
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#b4f7d3a0",
                  }}
                >
                  <BookmarkAddIcon sx={{ fontSize: 28, color: "#10b981" }} />
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="16px"
                  fontWeight="550"
                  color="text.secondary"
                >
                  Unused Coupons
                </Typography>
                <Box sx={{ position: "relative", width: 64, height: 64 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: "30px",
                      color: "text.secondary",
                    }}
                  >
                    {couponsData?.notUsedCoupons}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </>
  );
}

export default SalesReports;
